export const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    width: 300,
    margin: 100,
    padding: 0,
  },
  //style for font size
  resize: {
    fontSize: 50,
    padding: 0,
  },
};
